var _module = require('../../components/module');
var config = require('config');

require('angular-ui-bootstrap/src/modal');
require('angular-input-masks');
require('../lr-touch');
require('../user');
require('../fullscreen-loading');
require('../thankyou-modal');
require('../error-modal');
require('../analytics');
require('../../components/window-height');

_module.requires.push('ui.bootstrap.module.modal', 'ui.utils.masks');

_module.service('$contactListingAgentModal', [
    '$log',
    '$http',
    '$location',
    '$timeout',
    '$uibModal',
    '$fsloading',
    '$errorModal',
    '$analytics',
    '$q',

    function $contactListingAgentModalService($log, $http, $location, $timeout, $uibModal, $fsloading, $errorModal, $analytics, $q) {
        /*
        @function openContactListingAgentModal
        */
        return function openContactListingAgentModal(listing) {
            var modal = $uibModal.open({
                animation: false,
                template: require('./index.html'),
                controller: ['$scope', function contactListingAgentModalCtrl($scope) {
                    // Model

                    $log.debug('listing to be contacted about', listing);

                    $scope.contactFormData = {};


                    // Scope Functions

                    $scope.contact = function contact() {

                        if($scope.contactForm.$valid) {
                            $fsloading.show();

                            $http.post('/v1/emails/listhub-contact-agent', {
                                listingId: listing.id,
                                listingAddress: listing.address,
                                listingAgentPhone: listing.realtor.phone,
                                listingAgentEmail: listing.realtor.email,
                                listingAgentName: [listing.realtor.first_name, listing.realtor.last_name].filter(Boolean).join(' '),
                                consumerName: $scope.contactFormData.name,
                                consumerEmail: $scope.contactFormData.email,
                                consumerPhone: $scope.contactFormData.phone,
                            })
                                .then(function (emailResponse) {
                                    $scope.$close();
                                })
                                .catch(function saveUserError(err) {
                                    $log.error(err);
                                    $errorModal();
                                })
                                .finally(function saveUserFinally() {
                                    $fsloading.hide();
                                });
                        }
                    };


                }],
                backdrop: 'static',
                keyboard: false,
                windowClass: 'get-alerts-modal'
            });

            return modal.result;
        };
    }
]);
